export default __webpack_public_path__ + "static/Corprate_WhoWeAre_BoardofDirectors-A_03-436f1751bf041609b8582b8eb677c64f.gif";